import React from 'react';
import { UserLink } from '../../Links/Links';
import { Desktop, Mobile } from '../../MediaQuery';
import { useAppContext } from '../../../store/appContext';
import { logout } from '../../../common/actions/authActions';
import timerQueue, { EventType } from '../../../helpers/TimerQueue';
import { useUrlBuilder } from '../../../hooks/useUrlBuilder';
import { track } from '../../../helpers/tracking/tracking';
import { userSignsOutEvent } from '../../../common/models/TrackingEvents';
import { fontFamilies } from '../../UI/Font';

const AuthLinks = () => {
  const {
    email,
    paths: { account: basePathAccount },
  } = useAppContext();

  const { withCDN } = useUrlBuilder();

  const handleLogout = () => {
    logout(() => {
      timerQueue.addEvent({
        callback: () => window.location.reload(),
        type: EventType.Navigation,
      });
      timerQueue.addEvent({
        callback: () => track(userSignsOutEvent, { user: { email } }),
        type: EventType.UserEvent,
      });
    });
  };

  return (
    <>
      <Desktop>
        <UserLink id="my-account-desktop" href={basePathAccount} data-cy="header-account-link" padding="10px 0 0 0">
          My account
        </UserLink>
      </Desktop>

      <Mobile>
        <div className="my-account-link-container">
          <a
            className="my-account-link"
            id="my-account-mobile"
            href={basePathAccount}
            data-cy="anchor-navigation-my-account"
          >
            My account
          </a>
          <img className="my-account-arrow-img" src={withCDN('mkt/icon/arrow_right_black.png')} />
        </div>

        <style jsx>
          {`
            .my-account-link-container {
              position: relative;
              color: #222222;
              border-top: 1px solid #cccccc;
              border-bottom: 1px solid #cccccc;
              display: flex;
              flex: 1;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 17px;
              font-size: 15px;
              font-family: ${fontFamilies.light};
            }

            .my-account-link {
              padding: 10px;
              width: 100%;
              font-size: 15px;
              text-decoration: none;
            }

            .my-account-arrow-img {
              height: 17px;
              position: absolute;
              width: 17px;
              right: 5px;
              pointer-events: none;
            }
          `}
        </style>
      </Mobile>
      <UserLink onClick={() => handleLogout()} data-cy="header-signout-link" padding="10px 15px 0" border>
        Log out
      </UserLink>
    </>
  );
};

export default AuthLinks;
